// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_text__exFhF {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #696969;
}

.styles_forgetContainer__m2PFH {
  width: 450px !important;
}

.styles_forgetContainer__m2PFH p {
  margin: 0.5em 0;
}

.styles_inputContainer__MEPpK {
  margin-bottom: 30px;
}

.styles_wrapper__ALRoP {
  width: 100%;
}

.styles_formButton__Kle9m {
  width: 100% !important;
}

.styles_formButton__Kle9m > button {
  width: 100% !important;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.styles_submitItem__k0byg.styles_upload__c8baI {
  margin: 0em 5px;
  margin-top: 2em;
  cursor: pointer;
  width: auto;
  min-width: 154px;
  padding: 6px 24px;
  width: auto;
  border-radius: 4px;
  border-radius: 4px;
}

.styles_submitItem__k0byg.styles_upload__c8baI span {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 25px;
  color: #ffffff;
  text-align: center;
}

.styles_textNote__Hs0Ky {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #707070;
}

.styles_inputStyle__mcVlB {
  width: 420px !important;
  height: 44px;
}

@media only screen and (max-width: 1024px) {
  .styles_inputStyle__mcVlB {
    width: 353px !important;
    height: 44px;
  }
  .styles_text__exFhF,
  .styles_textNote__Hs0Ky {
    max-width: 353px;
  }
  .styles_forgetContainer__m2PFH {
    max-width: 353px !important;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/ForgetPasswordSuccess/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AACA;EACE,mBAAA;AAEF;;AAAA;EACE,WAAA;AAGF;;AADA;EACE,sBAAA;AAIF;;AAFA;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAKF;;AAHA;EACE,eAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EAEA,kBAAA;EAKA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACF;;AAEA;EACE,uBAAA;EACA,YAAA;AACF;;AAEA;EACE;IACE,uBAAA;IACA,YAAA;EACF;EAEA;;IAEE,gBAAA;EAAF;EAGA;IACE,2BAAA;EADF;AACF","sourcesContent":[".text {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  text-align: center;\n  color: #696969;\n}\n\n.forgetContainer {\n  width: 450px !important;\n}\n\n.forgetContainer p {\n  margin: 0.5em 0;\n}\n.inputContainer{\n  margin-bottom:30px;\n}\n.wrapper{\n  width:100%;\n}\n.formButton{\n  width:100% !important;\n}\n.formButton>button{\n  width:100% !important;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.submitItem.upload {\n  margin: 0em 5px;\n  margin-top: 2em;\n  cursor: pointer;\n  width: auto;\n  min-width: 154px;\n  padding: 6px 24px;\n  width: auto;\n  // height: 36px;\n  border-radius: 4px;\n  // border: 1px solid #ffffff;\n  // color: #ffffff !important;\n// background-color: inherit;\n  // background: #e30813;\n  border-radius: 4px;\n}\n\n.submitItem.upload span {\n  font-style: normal;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 25px;\n  color: #ffffff;\n  text-align: center;\n}\n\n.textNote {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 20px;\n  color: #707070;\n}\n\n.inputStyle {\n  width: 420px !important;\n  height: 44px;\n}\n\n@media only screen and (max-width: 1024px) {\n  .inputStyle {\n    width: 353px !important;\n    height: 44px;\n  }\n\n  .text,\n  .textNote {\n    max-width: 353px;\n  }\n\n  .forgetContainer {\n    max-width: 353px !important;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `styles_text__exFhF`,
	"forgetContainer": `styles_forgetContainer__m2PFH`,
	"inputContainer": `styles_inputContainer__MEPpK`,
	"wrapper": `styles_wrapper__ALRoP`,
	"formButton": `styles_formButton__Kle9m`,
	"submitItem": `styles_submitItem__k0byg`,
	"upload": `styles_upload__c8baI`,
	"textNote": `styles_textNote__Hs0Ky`,
	"inputStyle": `styles_inputStyle__mcVlB`
};
export default ___CSS_LOADER_EXPORT___;
